import React, { useEffect } from 'react';
import '../../../assets/css/patient/About.css';
import MyNavbar from '../../../components/general/navbar/MyNavbar';
import Footer from '../../../components/general/footer/Footer';

export default function About() {

  const features = ['🎯 Personalized Treatment Plans', '📿 Faith-Integrated Therapy', '🏆 Board-Certified Team', '💬 Real, Measurable Progress'];

  const values = [
    {
      icon: '☀️',
      arabic: 'إِنَّ مَعَ الْعُسْرِ يُسْرًا',
      title: 'Excellence',
      text: 'We hold every therapy session to the highest clinical standard, continuously refining our methods to give each patient outcomes they can measure.',
    },
    {
      icon: '🤲',
      arabic: 'وَرَحْمَتِي وَسِعَتْ كُلَّ شَيْءٍ',
      title: 'Compassion',
      text: 'Every patient is met with individual attention in a calm, judgment-free space — because recovery happens faster when people feel respected.',
    },
    {
      icon: '💡',
      arabic: 'وَعَلَّمَكَ مَا لَمْ تَكُن تَعْلَمُ',
      title: 'Innovation',
      text: 'We combine AI-assisted speech analysis with evidence-based therapy protocols, keeping our diagnostics and treatment plans current with the science.',
    },
  ];

  const journey = [
    { title: 'Founded', desc: 'Opened with two therapists and one goal: pair evidence-based speech therapy with the healing tradition of the Holy Quran.' },
    { title: 'AI Integration', desc: 'Introduced AI-assisted speech analysis, letting our clinicians diagnose earlier and track patient progress with more precision.' },
    { title: 'Quranic Healing Program', desc: 'Formalized our Quranic Voice Therapy Program, treating the physical voice and the wellbeing behind it as one course of care.' },
    { title: 'Regional Leader', desc: 'Now serving 5,000+ patients across the region, with an expanded clinical team and facilities built for that growth.' },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="ab-wrapper">
      <MyNavbar />

      {/* ===== HERO ===== */}
      <section className="ab-hero">
        <div className="ab-hero-bg"></div>
        <div className="ab-hero-inner">
          <div className="ab-hero-badge">
            <span className="ab-hero-dot"></span>
           Compassionate Care, Backed by Science
          </div>  
          <h1 className="ab-hero-title">
            Your Voice Matters,<br />
            <span className="ab-hero-accent">And So Does Your Story</span>
          </h1>
          <p className="ab-hero-sub">
            We're a team of licensed speech-language pathologists who blend modern clinical
            therapy with the timeless comfort of the Holy Quran — because healing works best
            when it speaks to the whole person.
          </p>
          <div className="ab-hero-features">
            {features.map((f, i) => <div key={i} className="ab-hero-feat">{f}</div>)}
          </div>
        </div>
      </section>

      {/* ===== MISSION ===== */}
      <section className="ab-mission">
        <div className="ab-container ab-mission-grid">

          <div className="ab-mission-text">
            <div className="ab-section-tag">Our Approach</div>
            <h2 className="ab-h2">Clinical Care, Met With Compassion</h2>
            <p className="ab-p">
              Founded in 2010, we set out to help people overcome communication challenges
              through the healing power of the Holy Quran combined with modern speech science.
            </p>
            <p className="ab-p">
              Our certified pathologists follow evidence-based practice, guided by the same
              principles of care and mercy that shape the rest of what we do — because recovery
              is rarely only physical.
            </p>
          </div>

          <div className="ab-mission-panel">
            <p className="ab-arabic">وَنُنَزِّلُ مِنَ الْقُرْآنِ مَا هُوَ شِفَاءٌ وَرَحْمَةٌ</p>
            <p className="ab-arabic-trans">"We send down of the Quran that which is healing and mercy."</p>
            <span className="ab-arabic-ref">Al-Isra, 17:82</span>
          </div>

        </div>
      </section>

      {/* ===== JOURNEY ===== */}
      <section className="ab-journey">
        <div className="ab-container">
          <div className="ab-section-head">
            <div className="ab-section-tag">Our Story</div>
            <h2 className="ab-h2">A Journey of Healing &amp; Growth</h2>
            <p className="ab-section-sub">From a small clinic to a regional leader — every milestone shaped who we are.</p>
          </div>

          <div className="ab-journey-grid">
            {journey.map((item, i) => (
              <div key={i} className="ab-journey-card">
                <h3 className="ab-journey-title">{item.title}</h3>
                <p className="ab-journey-desc">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== VALUES ===== */}
      <section className="ab-values">
        <div className="ab-container">
          <div className="ab-section-head">
            <div className="ab-section-tag">What Drives Us</div>
            <h2 className="ab-h2">Our Core Values</h2>
          </div>

          <div className="ab-values-grid">
            {values.map((value, index) => (
              <div key={index} className="ab-value-card">
                <div className="ab-value-icon-wrap"><span>{value.icon}</span></div>
                <p className="ab-value-arabic">{value.arabic}</p>
                <h3 className="ab-value-title">{value.title}</h3>
                <p className="ab-value-text">{value.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}